import React from "react";
import PropTypes from "prop-types";
import { WarningIcon } from "../../Icons";
import { Image } from "@learningblocks/shared-components";
import className from "./style.module.scss";

function ComponentBody(props) {
  return (
    <>
      <div className={className.body_ImageBlock}>
        <Image src={WarningIcon} alt="error-toast" />
      </div>
      <div className={className.body_TextBlock}>
        <h5>{props.title}</h5>
        <p>{props.message}</p>
      </div>
    </>
  );
}

ComponentBody.propTypes = {
  /**
   * Title of the toast
   */
  title: PropTypes.string,
  /**
   * message of the toast
   */
  message: PropTypes.string,
  /**
   * closeToast [ injected by library]
   */
  closeToast: PropTypes.func,
  /**
   * toastProps [ injected by library]
   */
  toastProps: PropTypes.object,
};

ComponentBody.defaultProps = {};

export const ErrorToast = {
  className: className.errorToast,
  bodyClassName: className.body,
  progressClassName: className.progress,
  Body: ComponentBody,
};
